import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const PrayerReservationPage = lazy(() => import('../pages/prayer-reservation/page'));
const ChushinuraPage = lazy(() => import('../pages/chushingura/page'));
const FestivalsPage = lazy(() => import('../pages/festivals/page'));
const TalismansPage = lazy(() => import('../pages/talismans/page'));
const AccessPage = lazy(() => import('../pages/access/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const MyPage = lazy(() => import('../pages/mypage/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/prayer-reservation',
    element: <PrayerReservationPage />,
  },
  {
    path: '/chushingura',
    element: <ChushinuraPage />,
  },
  {
    path: '/festivals',
    element: <FestivalsPage />,
  },
  {
    path: '/talismans',
    element: <TalismansPage />,
  },
  {
    path: '/access',
    element: <AccessPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/register',
    element: <RegisterPage />,
  },
  {
    path: '/mypage',
    element: <MyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
